import { _ as e, a as t, i as n, n as r, r as i, v as a, y as o } from "./generated-DMzJ0dir.js";
import { useMemoize as s } from "@vueuse/core";
//#region src/composables/useAddressService.ts
var c = () => e.getConfig().auth, l = (t = { token: void 0 }) => {
	if (t.token) {
		let n = {
			baseUrl: o,
			auth: t.token
		};
		return t.environment && t.environment === "acceptance" && (n.baseUrl = a), t.locale && (n.headers = {
			...n.headers,
			"Accept-Language": t.locale
		}), e.setConfig(n), t.token;
	}
	if (!t.baseUrl) throw Error("Either token or baseUrl is required");
	let n = {
		baseUrl: `${t.baseUrl}/address`,
		credentials: "include"
	};
	t.locale && (n.headers = {
		...n.headers,
		"Accept-Language": t.locale
	}), e.setConfig(n);
}, u = (t) => {
	e.setConfig({ headers: {
		...e.getConfig().headers,
		"Accept-Language": t
	} });
}, d = s(async (e) => (await t({ query: e })).data, { cache: /* @__PURE__ */ new Map() }), f = s(async (e) => (await n({ query: e })).data, { cache: /* @__PURE__ */ new Map() }), p = (e) => ["US", "CA"].includes(e), m = (e) => {
	switch (e) {
		case "US": return Object.values(i);
		case "CA": return Object.values(r);
		default: return [];
	}
}, h = async (e) => {
	let { countryCode: t, postalCode: n, houseNumber: r } = e;
	if (!(t !== "NL" || !n || !r)) try {
		let e = (await f({
			countryCode: t,
			postalCode: n.trim(),
			houseNumber: r.trim()
		}))?.results?.[0];
		return e ? {
			street: e.street,
			city: e.city
		} : void 0;
	} catch (e) {
		let t = e;
		return console.error("Error fetching address:", t), { error: `Failed to fetch address: ${t.message}` };
	}
};
function g() {
	return {
		setAcceptLanguageHeader: u,
		getStreetAndCity: h,
		getAddresses: f,
		doesCountryHaveStates: p,
		getStatesForCountry: m,
		getToken: c,
		initClient: l,
		validate: d
	};
}
//#endregion
export { g as t };
